import script from "./TruckDimensions.vue?vue&type=script&setup=true&lang=js"
export * from "./TruckDimensions.vue?vue&type=script&setup=true&lang=js"

import "./TruckDimensions.vue?vue&type=style&index=0&id=1524ca1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1524ca1a"]])

export default __exports__